'use client';

import { Typography } from '@/components/atoms/Typography/Typography';
import { CustomLink } from '@/components/atoms/CustomLink/CustomLink';
import { Image } from '@/components/atoms/Image/Image';
import * as Styled from '../ProjectsList/ProjectsList.styled';
import { JSX } from 'react';
import React, { forwardRef } from 'react';

interface IProjectList {
  numProjectsToShow: number;
  className?: string;
  ref?: React.Ref<HTMLUListElement>;
}

/** A skeleton loader for the projects list on the FilteredProjectsGallery component
 *  @param {IProjectList} props
 *  @param {number}       props.numProjectsToShow
 *  @return {JSX.Element}
 **/
export const ProjectsLoader = forwardRef<HTMLDivElement, Omit<IProjectList, 'ref'>>(
  ({ numProjectsToShow, className }, ref): JSX.Element => {
    return (
      <Styled.ProjectList
        isLoader={true}
        ref={ref}
        data-loader
        className={className}
      >
        <Styled.ListTitleAndLink>
          <Styled.TitleContainer></Styled.TitleContainer>
          <Typography text={'&nbsp;'} className="service-title" />
        </Styled.ListTitleAndLink>

        <Styled.ProjectsGrid style={{ opacity: 0.6 }} data-loader>
          {Array.from({ length: numProjectsToShow }, (_, i) => (
            <CustomLink key={`project-${i}`} imageHoverEffect={true} isDisabled={true}>
              <Styled.Project key={`project-${i}`} isPrivate={false}>
                <Image
                  src={''}
                  alt=""
                  includeContainer={true}
                  aspectRatio="1.5"
                  isLoader={true}
                />
                <Styled.TextContainer></Styled.TextContainer>
              </Styled.Project>
            </CustomLink>
          ))}
        </Styled.ProjectsGrid>
      </Styled.ProjectList>
    );
  }
);

ProjectsLoader.displayName = 'ProjectsLoader';
